import { MyTasksExcelState, MyTasksExcelActionTypes, DOWNLOAD_MY_TASKS_EXCEL_REQUEST, DOWNLOAD_MY_TASKS_EXCEL_SUCCESS, DOWNLOAD_MY_TASKS_EXCEL_FAILURE } from "store/reducers/types/myTasks/myTasksExcel";

const defaultState: MyTasksExcelState = {
  isLoading: false,
  errorMessage: ""
};

export default function myTasksExcel(state = defaultState, action: MyTasksExcelActionTypes): MyTasksExcelState {
  switch (action.type) {
    case DOWNLOAD_MY_TASKS_EXCEL_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case DOWNLOAD_MY_TASKS_EXCEL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    case DOWNLOAD_MY_TASKS_EXCEL_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};